module.exports = __webpack_public_path__ + "static/videos-illustration-d3f27463fa64f5f11636666c7bd43c41.webp";